export default __webpack_public_path__ + "static/media/gallery_07.fff6a443.jpg";